export const changeGTSymbol = (title) => {
  if (title) {
    if (title.includes('&gt;')) {
      title = title.replace(/&gt;/, '>');
    }
  }

  return title;
};

export const debounce = (callback, delay = 1000) => {
  let timeout;
  return (...args) => {
   
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      
      callback(...args);
    
    }, delay);
  };
};

export const reloadUrl = () => {
  setTimeout(()=>{ window.location.reload() }, 500);
}